import type { IconSvgObject } from './types';

const EthereumRectangleIcon: IconSvgObject = [
  ["path", { d: "M19.5 2.50039L4.50005 2.50005C3.39546 2.50002 2.5 3.39546 2.5 4.50005V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.50039C21.5 3.39584 20.6046 2.50041 19.5 2.50039Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.45885 12.1721L12 13.5L15.5411 12.1721M8 12L12 6L16 12L12 18L8 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EthereumRectangleIcon;
